import React from 'react';
import { Box, IconButton } from '@chakra-ui/react';
import { CheckboxArrayControl } from 'formComponents/CheckboxArrayControl';
import { ServiceInfo } from 'types';
import { InfoIcon, InfoService } from 'components';
import styled from '@emotion/styled';

interface Props {
  id: string;
  name: string;
  disabled: boolean;
  showWarning: boolean;
  service: ServiceInfo;
  showInfo: (id: string) => void;
  otherServicesOnly?: boolean;
}

const BoxStyled = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.space[4]};
  background-color: ${({ theme }) => theme.colors.white};
  &:first-of-type {
    border-radius: ${({ otherServicesOnly }) =>
      otherServicesOnly ? '8px 8px 0 0' : 0};
  }
  &:last-of-type {
    border-radius: 0 0 8px 8px;
  }
  &:not(:last-of-type) {
    border-bottom-width: 1px;
  }
`;

export const ServiceBox: React.FC<Props> = ({
  id,
  name,
  disabled,
  showWarning,
  service,
  showInfo,
  otherServicesOnly = false,
}) => (
  <BoxStyled otherServicesOnly={otherServicesOnly} gridGap={6}>
    <CheckboxArrayControl
      name={name}
      isDisabled={disabled}
      size="lg"
      value={id}
    />
    <Box w="100%">
      <InfoService service={service} warning={showWarning} showCountInput />
    </Box>
    <IconButton
      rounded="full"
      variant="ghost"
      icon={<InfoIcon warning={showWarning ? 1 : 0} />}
      aria-label="Назад в выбор услуг"
      onClick={(e) => {
        showInfo(id);
        e.stopPropagation();
      }}
    />
  </BoxStyled>
);
